import { Directive, input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[pnDialogTemplate]',
})
export class PnDialogTemplate {
    name = input.required<'header' | 'footer' | 'headless'>({ alias: 'pnDialogTemplate' });

    constructor(public templateRef: TemplateRef<unknown>) {}
}
